import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Login from '../pages/Login/index';
import Dashboard from '../pages/Dashboard/index';
import AuthConfirm from '../pages/AuthConfirm';


import ForgotPassword from '../pages/ForgotPassword';
import UpdatePassword from '../pages/UpdatePassword';



// Main App Routes
const AppRoutes: React.FC = () => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Normalize path to avoid accidental double slashes from external links
  if (location.pathname.startsWith('//')) {
    const normalizedPath = location.pathname.replace(/^\/+/, '/');
    navigate({ pathname: normalizedPath, search: location.search }, { replace: true });
    return null;
  }

  // Show loading overlay while checking authentication (full screen)
  if (loading) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-2 border-blue-600 border-t-transparent"></div>
        <p className="text-gray-600 mt-4">Loading...</p>
      </div>
    );
  }

  // Check if user needs to change password (first login)
  const isFirstLogin = isAuthenticated && location.pathname !== '/update-password' && 
    location.search !== '?force=true' && 
    user?.user_metadata?.is_first_login === true;

  // Force password change for first login
  if (isFirstLogin) {
    return <Navigate to="/update-password?force=true" replace />;
  }

  return (
    <Routes>   
      
      {!isAuthenticated ? (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/update-password" element={<UpdatePassword />} />
          <Route path="/auth/confirm" element={<AuthConfirm />} />
        </>
      ) : (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </>
        )
      }
    </Routes>
  );
};

export default AppRoutes;
